const URL_ROOT = 'https://ltmis.neuedu.com'; //'https://ltmis.neuedu.com'; // 'http://10.199.164.44:8099' 'https://ltmismanagetest.neuedu.com'
const URL_API = URL_ROOT + '/api/v2021.1';

const URL_UPLOAD_FOLDER = URL_ROOT + '/upload';
const URL_DOWNLOAD = URL_API + '/common/download?attFileId=';
const URL_CER_DOWNLOAD = URL_API + '/study/certificate/mergeDown?classId=';

export default {
    URL_ROOT: URL_ROOT,
    URL_API: URL_API,
    URL_UPLOAD: URL_UPLOAD_FOLDER,
    URL_DOWNLOAD: URL_DOWNLOAD,
    URL_CER_DOWNLOAD: URL_CER_DOWNLOAD,
};
